'use client';

import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import colors from '@/styles/themes/colors';

import styles from './OfficeShowcaseSection.module.scss';

const OfficeShowcaseSection = () => {
  const t = useTranslations('office.officeShowcase');

  const galleryImages = [
    { src: '/images/office/office-1.webp', alt: 'Workspace office desk' },
    { src: '/images/office/office-2.webp', alt: 'Workspace workstation' },
    { src: '/images/office/office-3.webp', alt: 'Full-service digital studio' },
    { src: '/images/office/office-4.webp', alt: 'Workspace interior' },
  ];

  return (
    <Container component="section" maxWidth={false} disableGutters className={styles.container}>
      <Box className={styles.heroImageWrapper}>
        <Image
          src="/images/office/tehnoloski-park.split.webp"
          alt="Workspace office building"
          fill
          className={styles.heroImage}
        />
      </Box>
      <Container maxWidth="xl" className={styles.contentWrapper}>
        <Grid container spacing={{ xs: 8, lg: 3 }} alignItems="flex-start">
          <Grid size={{ xs: 12, lg: 6 }} order={{ xs: 2, lg: 1 }}>
            <Stack spacing={3}>
              <Grid container spacing={3}>
                <Grid size={4}>
                  <Box className={`${styles.galleryItem} ${styles.galleryItem1}`}>
                    <Image src={galleryImages[0].src} alt={galleryImages[0].alt} fill className={styles.galleryImage} />
                  </Box>
                </Grid>
                <Grid size={8}>
                  <Box className={`${styles.galleryItem} ${styles.galleryItem2}`}>
                    <Image src={galleryImages[1].src} alt={galleryImages[1].alt} fill className={styles.galleryImage} />
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid size={6}>
                  <Box className={`${styles.galleryItem} ${styles.galleryItem3}`}>
                    <Image src={galleryImages[2].src} alt={galleryImages[2].alt} fill className={styles.galleryImage} />
                  </Box>
                </Grid>
                <Grid size={6}>
                  <Box className={`${styles.galleryItem} ${styles.galleryItem4}`}>
                    <Image src={galleryImages[3].src} alt={galleryImages[3].alt} fill className={styles.galleryImage} />
                  </Box>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }} order={{ xs: 1, lg: 2 }}>
            <Stack gap={4}>
              <Typography
                component="h2"
                variant="h4"
                sx={{ typography: { lg: 'h2' } }}
                dangerouslySetInnerHTML={{ __html: t.raw('title') }}
              />
              <Typography
                component="p"
                variant="subtitle2"
                color={colors.graytone200}
                dangerouslySetInnerHTML={{ __html: t.raw('description') }}
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default OfficeShowcaseSection;
